module.exports = __webpack_public_path__ + "img/pdd.407e79cd.png";